import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';
import { apiGet } from 'APIPackage/MainModule/common/apiTools';

import { IMspCategory } from '../interfaces/IMspCategory';

export async function fetchMspCategories(): Promise<IMspCategory[]> {
  return apiGet<IMspCategory[]>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/msp-categories`);
}
